import React, { useMemo } from 'react';
import { Table as LegoTable } from '@lucid/lego';
import { ProspectTestDrive } from '../../../../../../api/services/lupp/prospect/dto.test-drive-schedule';
import { createColumns } from './utils';

type TableProps = {
  theme: 'light' | 'dark';
  data: ProspectTestDrive[];
  labels: Record<string, string>;
  onViewClick: (record: ProspectTestDrive) => void;
  locale?: string;
};

const Table: React.FC<TableProps> = ({ theme, data, labels, onViewClick, locale = 'en-US' }) => {
  const columns = useMemo(
    () => createColumns({ theme, onViewClick, labels, locale }),
    [theme, onViewClick, labels, locale]
  );

  return (
    <LegoTable
      columns={columns}
      data={data}
      theme={theme === 'light' ? 'dark' : 'light'}
      pagination={{
        enabled: true,
        pageSize: 10,
      }}
      labels={{
        showingItems:
          labels?.['configurator.table.showingItems'] ??
          'Showing {{start}}-{{end}} of {{total}} Items',
      }}
      emptyState={{
        message:
          labels?.['testDrive.noTestDrives'] || 'No test drives booked yet for this prospect.',
      }}
      gaComponent="test-drives-table"
      dataTestId="test-drives-table"
      selection={{ enabled: false }}
    />
  );
};

Table.displayName = 'TestDrivesTable';

export default Table;
